import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { Mutex } from "async-mutex"

import { API_BASE_URL } from "constants/constants"
import { API_CORE_URL } from "constants/config"
import { getAccessToken, getRefreshToken, saveAccessToken, saveRefreshToken } from "utils/token"

const mutex = new Mutex()

export const authBaseQuery = (baseUrl: string) => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: headers => {
      const token = getAccessToken()
      if (token) {
        headers.set("Authorization", `Bearer ${token}`)
      }
      return headers
    },
  })

  const coreBaseQuery = fetchBaseQuery({ baseUrl: API_CORE_URL })

  return async (args, api, extraOptions) => {
    await mutex.waitForUnlock()
    let result = await baseQuery(args, api, extraOptions)

    if (result.error?.status !== 401) {
      return result
    }

    if (mutex.isLocked()) {
      await mutex.waitForUnlock()
      return baseQuery(args, api, extraOptions)
    }

    const release = await mutex.acquire()

    try {
      const refreshTokenResult = await coreBaseQuery(
        {
          url: `Token/ValidateRefreshToken`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          body: { refreshToken: getRefreshToken() },
        },
        api,
        extraOptions,
      )

      const data = refreshTokenResult?.data as { access_token: string; refresh_token: string }

      if (data?.access_token && data.refresh_token) {
        saveAccessToken(data.access_token)
        saveRefreshToken(data.refresh_token)
        result = await baseQuery(args, api, extraOptions)
      } else {
        sessionStorage.clear()
        window.location.href = "/"
      }
    } finally {
      release()
    }

    return result
  }
}

export const api = createApi({
  baseQuery: authBaseQuery(API_BASE_URL ?? "/"),
  tagTypes: ["Gorp", "GorpReports", "Alps"],
  endpoints: () => ({}),
})
